import React from 'react';

function ProductionPlanCard({ plan, date, onClick, canEdit }) {
  const formatNumber = (n) => {
    if (n === null || n === undefined) return '—';
    return new Intl.NumberFormat('ru-RU').format(n);
  };

  return (
    <div
      className={`production-card ${canEdit ? 'clickable' : ''}`}
      onClick={canEdit ? onClick : undefined}
      title={canEdit ? 'Нажмите, чтобы изменить план' : 'План на день'}
    >
      <div className="production-icon">📦</div>
      <div className="production-info">
        <div className="production-label">План на день</div>
        <div className="production-value">
          {plan && plan.plan_amount !== null ? (
            <>
              {formatNumber(plan.plan_amount)}
              <span className="production-unit"> ланчбоксов</span>
            </>
          ) : (
            <span style={{ color: '#adb5bd', fontStyle: 'italic' }}>
              не задан
            </span>
          )}
        </div>
      </div>
      {canEdit && (
        <div className="production-edit-icon">✏️</div>
      )}
    </div>
  );
}

export default ProductionPlanCard;